import axios from "axios";//创建一个axios的对象
//生成一个axios的实例
const http=axios.create({
	baseURL:"https://portalafter.chonghaotech.com/prod-api",// baseURL会在发送请求的时候拼接在url参数前面
	//baseURL:"http://localhost/dev-api",
	timeout:10000,//请求超时
});
export default http;//导出


// WEBPACK FOOTER //
// ./src/utils/request.js